import * as MaterialUI from '@mui/material';
import * as Styled from './styles';
import * as React from 'react';
import { InPageNavigationProps, Link } from './config';
import { useEffect } from 'react';

const InPageNavigation = (props: InPageNavigationProps) => {
  const [linkHeadings, setLinkHeadings] = React.useState<string[]>([]);
  const [convertedLinks, setConvertedLinks] = React.useState<Link[]>([]);

  useEffect(() => {
    if (!props.links) return;
    if (typeof props.links === 'string') {
      setConvertedLinks(JSON.parse(props.links));
    } else {
      setConvertedLinks(props.links);
    }
  }, [props.links]);

  useEffect(() => {
    convertedLinks.forEach(({ label, url }) => {
      const heading = findFirstHeader(url);
      setLinkHeadings((prevHeadings) => [...prevHeadings, heading]);
    });
  }, [convertedLinks]);

  function findFirstHeader(parentId: string): string {
    const HEADING_STRING = 'h1, h2,' + ' h3, h4,' + ' h5, h6';
    const HEADING_ARRAY = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];
    const parent = document.getElementById(parentId);
    if (!parent) return '';

    const headers = HEADING_ARRAY.includes(parent.tagName)
      ? [parent]
      : parent.querySelectorAll(HEADING_STRING);
    if (headers.length) return headers[0].textContent || '';

    return '';
  }

  function getLabel(i: number): string {
    return linkHeadings[i];
  }

  if (!props.links) return null;

  return (
    <MaterialUI.Box
      className={
        (props.horizontalPadding ? props.horizontalPadding : 'l-padding') +
        ' ' +
        (props.topVerticalPadding ? props.topVerticalPadding : 'module--flat-top') +
        ' ' +
        (props.bottomVerticalPadding
          ? props.bottomVerticalPadding
          : 'module--flat-bottom')
      }
    >
      {props.links && props.links.length >= 1 && (
        <MaterialUI.Box id={'inPageNavigation'}>
          <Styled.List>
            <Styled.ListItem>
              <MaterialUI.Typography variant={'body1'} fontWeight={'bold'} paddingTop={0}>
                On this page
              </MaterialUI.Typography>
            </Styled.ListItem>
            {convertedLinks.map(({ label, url }, i) => (
              <Styled.ListItem key={i}>
                <Styled.Link
                  onClick={() => {
                    const element = document.getElementById(url);
                    if (!element) return;
                    const offset = 30;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth',
                    });
                  }}
                >
                  {label ? label : getLabel(i)}
                </Styled.Link>
              </Styled.ListItem>
            ))}
          </Styled.List>
        </MaterialUI.Box>
      )}
    </MaterialUI.Box>
  );
};

export default InPageNavigation;

InPageNavigation.defaultProps = {};
